import React, {Component} from 'react';
import { BadgesService } from '../../services/badges';
import { CoinsService } from '../../services/coins';
import './webview.css';

import {
  ContentHeader,
  CoinsBox,
  BadgesBox
} from '../../components';

export default class ViewWebview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "render_coins_box": false,
      "render_badges_box": false
    }
  }

  componentDidMount() {
    this.sendCoins();
  }

  sendCoins() {
    var exist = CoinsService.exist("additional_content", "talk");

    if (!exist && this.props.match.params.id !== "10") {
      CoinsService.add({
        "type": "additional_content",
        "target": "talk",
        "coins": 3000
      })

      this.setState({
        "render_coins_box": true
      });
    }
  }

  onBack() {
    if (this.props.match.params.id === "10") {
      window.location = window.location.origin + window.location.pathname + "#/";
    } else {
      window.location = window.location.origin + window.location.pathname + "#/palestra/" + this.props.match.params.id;
    }
  }

  onCloseCoinsBox() {
    this.setState({
      "render_coins_box": false
    })
  }

  onFinish() {
    var exist = BadgesService.exist(this.props.match.params.id);
    if (!exist) {
      BadgesService.add({
        "id": this.props.match.params.id,
        "label": this.props.match.params.id === "10" ? "Compliance" : "Gerando valor juntos",
        "exist": true
      });
      this.setState({
        "render_badges_box": true
      })
    } else {
      this.onBack();
    }
  }

  getUrl() {
    var url = "https://api.digitalpages.com.br/product/composer_player/current/e3894d14dbb743d78a7efc5819edc52e/p/-/p/?custom_options=eyJjb250ZW50X3VpZCI6Ikg0c0lBQUFBQUFBQUNnQmlBWjMtQXdBQUFVRURBQUFBQURFME1HVXdZekUxWDU0aXBYeGRvZmVjYXo3N25yU0ZJa01ONmlLc1YxSlY2ZGc0aDJxeVlFZzAyeEctNUJjU2hDUmRsYlJHMTliUjJhWlJGRGI1bTd3d2FrTnJYMUFILXV1dUJxQVBmQ2UzQlRHcThFNDVxWWJiTXFKS1JIQ3hPLVdZYk1SQ09nNVRPR3dyS0lkUmJ6VHNDalNJTzFheDJrT014WVFDNWszX3hUUWtjdWJzX0NySjVWNzZYaUx5ZEZWVEpSNDVJR1ExWHA5RDRzZGRKR09ZcC1EMXJ2N3Y4bTluNFRqNUZERHpydHdrRWdoN0dtTUxMU3VmdDkwcXJ6bE5lWWstcFZTdFdpM2Z0T1lMRTlUZVZsb2lXMUFrVUpoQ0EydG4tc0pDTTN0akJXSDFHQ09qWGwwR3pVc3BFMFZzdkdtVFhkRWVhLXU0T3BvTWRHam8wVVhibExmZzJuSmpsN3VBSmt6enQ1MUZXbWczMEpMNVdldW5SZkN1YjFER1ZWeVBjbndQNTBSWEQ0QUR0ZlpyaVJIay1UOG9vN2ZrYkN5YlQwdEo2WmhDWUtCZno0aXNJei13U2tWTlB1eG1hN25WLWR1VkFBQUFfXzgiLCJhY2Nlc3NfdG9rZW4iOiIifQ==";
    if (this.props.match.params.id === "10") {
      url = "https://api.digitalpages.com.br/product/composer_player/current/e3894d14dbb743d78a7efc5819edc52e/p/-/p/?custom_options=eyJjb250ZW50X3VpZCI6Ikg0c0lBQUFBQUFBQUNnQmlBWjMtQXdBQUFVRURBQUFBQURFME1HVXdZekUxMHdVanV1a1gwU0pEc3pVc0xSU0p5OE1uaXBNN0U0aElPb0d5M1ZVaDU3c1oxd0xZZ3Y1bzJxeW1CcF9sdlhiLWxMRmdndGE1dTZIdUJiVG8yQUpzV3R4T01jUnhQMXJDU1JwWFVNRXpjcTZobEFOMTQxZW0tRG41WDlWUjBMT25Ja3MzcTZ4c21LazVxaE5DM3FoVDhLUS1ucXVWdnBxSmJOS3phODkwT2dYcDhLakVwSXBwLTREZUNBc09nU2NIV29Fc0NZRndaNlI5ZXRoSkRhekpUR0ItcGRUS1J2VGgza3JGeTUxUnB2b2FraW9hcDZiel9MZTB5Ql9Ga1BLMnc5c0dBWXhtUjJhaE5vZUVLSjR0bF9KZjh5TjRsMGw1S05WTXFXMnlHNXdDSXQ5ZFAzVlpsc0U0UzBVOUQ2VFdjVUZJUExRS1ZrcDZWMFJWSTNLN1FLekNmemh1Y0duYkRmMUk4aXlMYlJlRHd2RUpJV284T1RSTVp6QlRXaGY5aEE0RHh0bEJ6RlhwbzdoRXl3cURJaFZ6c3IxQjJLT05oQkdMMlU1bnpvbGV5WVBUVUJMYWN4NHRsamJES0VyMkFBQUFfXzgiLCJhY2Nlc3NfdG9rZW4iOiIifQ==";
    };
    return url;
  }

  getMessage() {
    var message = 'Parabéns! Você acaba de conquistar um carimbo especial por ter conferido o material adicional da palestra<br/><b>"Gerando valor juntos"';

    if (this.props.match.params.id === "10") {
      message = 'Parabéns! Você acaba de conquistar um carimbo especial por ter conferido o mini-curso de Compliance!';
    };
    return message;
  }

  render() {
    return <div className="rdp-react-template-view-webview">
      {this.state.render_badges_box &&
        <BadgesBox
          badgeLabel={this.props.match.params.id === "10" ? "Compliance" : "Gerando valor juntos"}
          title="Novo carimbo!"
          message={this.getMessage()}
          onClose={() => this.onBack()}
          buttonLabel={this.props.match.params.id === "10" ? "Voltar para o Início" : "Voltar para a Palestra"}
        />
      }
      {this.state.render_coins_box &&
        <CoinsBox
          title="Parabéns!"
          message="Você ganhou <b>3.000<br/><span style='color:#56c8e2;'>BV Coins</span>!</b>"
          onClose={() => this.onCloseCoinsBox()}
          buttonLabel="Voltar para o Conteúdo"
        />
      }
      <ContentHeader
        title={this.props.match.params.id === "10" ? "Compliance" : "Gerando valor juntos"}
        onBack={() => this.onBack()}
      />
      <iframe className="rdp-react-template-view-webview-iframe" src={this.getUrl()}/>
      <div className="rdp-react-template-view-webview-iframe-finish">
        <button className="rdp-react-template-view-webview-iframe-finish-btn" onClick={() => this.onFinish()}>Concluir e Fechar</button>
      </div>
    </div>;
  }
}
